import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatDialog } from '@angular/material/dialog'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { MatIcon } from '@angular/material/icon'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { TableListTariffSelectComponent } from '../../../shared/components/table-list-tariff-select/table-list-tariff-select.component'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { LocationService } from '../../../core/services/location/location/location.service'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { CommonModule } from '@angular/common'
import { Observable } from 'rxjs'
import { MatCardModule } from '@angular/material/card'
import { MatTooltip } from '@angular/material/tooltip'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'

interface LocationModel {
  id: number
  descricao: string
}

@Component({
  selector: 'search-tariff-page',
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressBar,
    PaginationComponent,
    TableListTariffSelectComponent,
    FormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatInput,
    MatIcon,
    MatAutocompleteModule,
    MatTooltip,
  ],
  templateUrl: './search-tariff-page.component.html',
  styleUrl: './search-tariff-page.component.scss',
  standalone: true,
  providers: [
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    TariffService,
    ViaCepService,
  ],
})
export class SearchTariffPageComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private viaCepService: ViaCepService,
    private tariffService: TariffService,
    private tariffTypeService: TariffTypeService,
    private dialog: MatDialog,
  ) {
    this.createForm()
  }

  filteredOrigins!: Observable<LocationModel[]>
  filteredDestinations!: Observable<LocationModel[]>

  item: any = { user: false, data: [] }
  multiSelect = false
  tableView = false
  isBlocked = false

  @Output() responseSearch = new EventEmitter()
  @Input() searchEvent = ''

  @Output() responseSingle = new EventEmitter()
  @Output() responseMulti = new EventEmitter()
  @Output() selectItemEvent = new EventEmitter()
  @Output() locationEvent = new EventEmitter()

  @Input() tariffSelected: any = {}
  @Input() edit = false
  @Input() idClient = 0

  isFillingForm = false

  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listTypeTariff: any[] = []
  listStandard: any[] = [
    { value: 'T', description: 'Ambos' },
    { value: 'S', description: 'Sim' },
    { value: 'N', description: 'Não' },
  ]
  listPerimeter: any[] = [
    { value: 'T', description: 'Ambos' },
    { value: 'S', description: 'Sim' },
    { value: 'N', description: 'Não' },
  ]
  listStatus: any[] = [
    { value: '', description: 'Ambos' },
    { value: 'S', description: 'Ativo' },
    { value: 'N', description: 'Inativo' },
  ]

  listServiceSpecification: any[] = []

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  searchForm = {}
  inputSearch = ''

  form: FormGroup = new FormGroup({})
  formOrigin: FormGroup = new FormGroup({})
  formDestination: FormGroup = new FormGroup({})

  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'typeTariff',
      key: 'tipoTarifario',
      // key: 'tipo',
      description: 'Tipo',
    },
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'cost',
      key: 'custo_formatado',
      description: 'Custo',
    },
    {
      keyColumn: 'custoExtra_HK',
      key: 'custo_formatado',
      description: 'Custo Extra',
    },
    {
      keyColumn: 'infoTariff',
      key: 'perimetroUrbano',
      description: 'Infos',
    },
    {
      keyColumn: 'validity',
      key: 'dataValidade',
      description: 'validade',
    },
  ]

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false

  ngOnInit() {
    // this.getListItems()
    this.getTypeService()
    this.getTypeVehicle()
    this.getTypeDriver()
    this.getTypeTariff()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      originDescription: [''],
      originCity: [''],
      originState: [''],
      destinationDescription: [''],
      destinationCity: [''],
      destinationState: [''],
      tariffType: [''],
      status: [''],
      serviceType: [''],
      specificationService: [''],
      vehicleType: [''],
      driverType: [''],
      // standard: ['T'],
      urbanPerimeter: ['T'],
    })
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeTariff() {
    this.tariffTypeService.listTariffType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeTariff = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  onSelectionChangeService(event: MatSelectChange) {
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    const specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
    // this.searchTariff()
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    this.form.get('vehicleType')!.clearValidators()
    this.form.get('driverType')!.clearValidators()
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
    // this.searchTariff()
  }

  getServiceSpecification(idType: number, idService = -1) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (idService >= 0) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == idService
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  checkService(specificationService: any) {
    if (specificationService) {
      if (
        specificationService.exigeVeiculo &&
        specificationService.exigeVeiculo.toLowerCase() == 's'
      ) {
        this.form.get('vehicleType')!.setValidators(Validators.required)
        this.form.get('driverType')!.setValidators(Validators.required)
        this.form.get('vehicleType')!.enable()
        this.form.get('driverType')!.enable()
      } else {
        this.form.get('vehicleType')!.clearValidators()
        this.form.get('driverType')!.clearValidators()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      }
    }
  }

  sendSearch(search = true) {
    if (search) {
      const searchModel: any = {
        // destination: this.form.get('destination')?.value,
        // driverType: this.form.get('driverType')?.value,
        // origin: this.form.get('origin')?.value,
        // serviceType: this.form.get('serviceType')?.value,
        // specificationService: this.form.get('specificationService')?.value,
        // standard: this.form.get('standard')?.value,
        // urbanPerimeter: this.form.get('urbanPerimeter')?.value,
        // vehicleType: this.form.get('vehicleType')?.value,

        tipoTarifarioId:
          this.form.get('tariffType')?.value != ''
            ? this.form.get('tariffType')?.value
            : 0,
        tarifarioStatus: this.form.get('status')?.value,
        origemId: 0,
        origem: '',
        destinoId: 0,
        destino: '',
        tipoServicoId:
          this.form.get('serviceType')?.value != ''
            ? this.form.get('serviceType')?.value
            : 0,
        tipoServico: '',
        servicoId:
          this.form.get('specificationService')?.value != ''
            ? this.form.get('specificationService')?.value
            : 0,
        servico: '',
        tipoVeiculoId:
          this.form.get('vehicleType')?.value != ''
            ? this.form.get('vehicleType')?.value
            : 0,
        tipoVeiculo: '',
        tipoMotoristaId:
          this.form.get('driverType')?.value != ''
            ? this.form.get('driverType')?.value
            : 0,
        tipoMotorista: '',
        clienteId: 0,
        cliente: '',
        fornecedorId: 0,
        fornecedor: '',
        // standard: this.form.get('standard')?.value,
        standard: 'N',
        perimetroUrbano: this.form.get('urbanPerimeter')?.value,
        origemDescricao: this.form.get('originDescription')?.value.trim(),
        origemCidade: this.form.get('originCity')?.value.trim(),
        origemEstado: this.form.get('originState')?.value.trim(),
        destinoDescricao: this.form.get('destinationDescription')?.value.trim(),
        destinoCidade: this.form.get('destinationCity')?.value.trim(),
        destinoEstado: this.form.get('destinationState')?.value.trim(),
      }
      this.responseSearch.emit({ search: search, model: searchModel })
    } else {
      this.form.get('destination')?.setValue('')
      this.form.get('driverType')?.setValue('')
      this.form.get('origin')?.setValue('')
      this.form.get('serviceType')?.setValue('')
      this.form.get('specificationService')?.setValue('')
      // this.form.get('standard')?.setValue('T')
      this.form.get('urbanPerimeter')?.setValue('T')
      this.form.get('vehicleType')?.setValue('')
      this.form.get('tariffType')?.setValue('')
      this.form.get('status')?.setValue('')
      this.form.get('originDescription')?.setValue('')
      this.form.get('originCity')?.setValue('')
      this.form.get('originState')?.setValue('')
      this.form.get('destinationDescription')?.setValue('')
      this.form.get('destinationCity')?.setValue('')
      this.form.get('destinationState')?.setValue('')
      this.responseSearch.emit({
        search: true,
        model: {
          tipoTarifarioId: 0,
          tarifarioStatus: '',
          origemId: 0,
          origem: '',
          destinoId: 0,
          destino: '',
          tipoServicoId: 0,
          tipoServico: '',
          servicoId: 0,
          servico: '',
          tipoVeiculoId: 0,
          tipoVeiculo: '',
          tipoMotoristaId: 0,
          tipoMotorista: '',
          clienteId: 0,
          cliente: '',
          fornecedorId: 0,
          fornecedor: '',
          // standard: 'T',
          standard: 'N',
          perimetroUrbano: 'T',
          origemDescricao: '',
          origemCidade: '',
          origemEstado: '',
          destinoDescricao: '',
          destinoCidade: '',
          destinoEstado: '',
        },
      })
    }

    // if (search && this.checkSearch()) {
    //   const searchModel = {
    //     clienteId: 0,
    //     nomeCliente: this.formSearch.get('client')!.value,
    //     subClienteId: 0,
    //     nomeSubCliente: this.formSearch.get('subClient')!.value,
    //     consultorId: 0,
    //     nomeConsultor: this.formSearch.get('consultantClient')!.value,
    //     nomeEvento: this.formSearch.get('event')!.value,
    //     formaPagamentoId: 0,
    //     prazo: '',
    //     statusPropostaId: this.formSearch.get('status')!.value,
    //     statusPropostaDescricao: '',
    //     consultorComercial: this.formSearch.get('consultantTg')!.value,
    //     dataInicio:
    //       this.formSearch.get('dateStart')!.value != ''
    //         ? moment(this.formSearch.get('dateStart')!.value).format(
    //           'DD/MM/YYYY',
    //         )
    //         : '',
    //     dataFim:
    //       this.formSearch.get('dateEnd')!.value != ''
    //         ? moment(this.formSearch.get('dateEnd')!.value).format('DD/MM/YYYY')
    //         : '',
    //   }
    //   this.responseSearch.emit({ search: search, model: searchModel })
    // } else if (!search) {
    //   this.formSearch.get('client')!.setValue('')
    //   this.formSearch.get('subClient')!.setValue('')
    //   this.formSearch.get('event')!.setValue('')
    //   this.formSearch.get('consultantClient')!.setValue('')
    //   this.formSearch.get('consultantTg')!.setValue('')
    //   this.formSearch.get('dateStart')!.setValue('')
    //   this.formSearch.get('dateEnd')!.setValue('')
    //   this.formSearch.get('status')!.setValue(0)
    //
    //   this.responseSearch.emit({ search: search, model: {} })
    // }
  }
}
